

class CookieService {

    getCookie(name: string) {
        const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
        return v ? v[2] : null;
    }

    setCookie(name: string, value: any, days: number) {
        let cookie = `${name}=${value};path=/`;
        if (days) {
            const d = new Date;
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
            cookie += `;expires=${d.toUTCString()}`;
        }
        document.cookie = cookie;
    }

    deleteCookie(name: string) {
        this.setCookie(name, '', -1);
    }
}


export var cookieService = new CookieService();
